import React from "react";
import { Tooltip } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import "./BaseFieldLabel.css";

/**
 * Field label with an optional help tooltip.
 *
 * `maxWidth` caps how wide the bubble may grow before the text wraps. Help text
 * often runs to a couple of sentences, and without a cap the bubble either
 * stretches across the screen or stays narrow enough to become a tall column.
 * The CSS clamps it to the viewport as well, so it stays readable on mobile.
 */
const BaseFieldLabel = ({ label, tooltip, placement = "top", maxWidth }) => {
  if (!tooltip) {
    return label;
  }

  const overlayStyle = maxWidth
    ? { "--base-field-label-tooltip-max-width": typeof maxWidth === "number" ? `${maxWidth}px` : maxWidth }
    : undefined;

  return (
    <span className="base-field-label">
      <span>{ label }</span>
      <Tooltip
        title={ tooltip }
        placement={ placement }
        trigger={ ["hover", "focus", "click"] }
        overlayClassName="base-field-label__tooltip"
        overlayStyle={ overlayStyle }
      >
        <span
          aria-label={ `About ${label}` }
          className="base-field-label__help"
          role="button"
          tabIndex={ 0 }
        >
          <QuestionCircleOutlined aria-hidden="true" />
        </span>
      </Tooltip>
    </span>
  );
};

export default BaseFieldLabel;
